import { UserQuelleAllgemein } from "./user-quelle-allgemein.model";

 

export class UserQuelleSonstige extends UserQuelleAllgemein  {

  idUserQuelleSonstige: number;
  quellenspezZusatzabstand: number;
  emissionGe: number;
}
